import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-remy-dark border-t border-white/10 py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <h3 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-remy-primary to-remy-accent">
                            Remy Group
                        </h3>
                        <p className="mt-2 text-gray-400 text-sm">
                            Creating digital experiences that matter.
                        </p>
                    </div>

                    <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-8 text-center md:text-right">
                        <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                            Privacy Policy
                        </Link>
                        <span className="text-gray-600 text-sm hidden md:inline">|</span>
                        <p className="text-gray-600 text-sm">
                            &copy; {new Date().getFullYear()} Remy Group. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
